import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

let tmpRoutes = [];

//================================== 登录
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      name: 'Login',
      path: '/login',
      component: () => import('@/views/login/Login'),
      meta: {
        title: '登录',
        requireLogin: false
      }
    },
    {
      name: 'Reg',
      path: '/reg',
      component: () => import('@/views/login/Reg'),
      meta: {
        title: '注册',
        requireLogin: false
      }
    },
    {
      path: '/sso',
      component: () => import('@/views/login/Sso'),
      meta: {
        title: '',//SSO
      }
    },
  ]);
})();

//================================== 个人中心
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      path: '/me/Index',
      name: 'MeIndex',
      component: () => import('@/views/me/Index'),
      meta: {
        requireLogin: true
      }
    },
    {
      path: '/MyProfile',
      name: 'MyProfile',
      component: () => import('@/views/me/MyProfile'),
      meta: {
        requireLogin: true
      }
    },
    /** 智能服务订单列表 **/
    {
      path: '/my_order/service_order_list',
      name: 'Serviceorderlist',
      component: () => import('@/views/myorder/Serviceorderlist'),
      meta: {
        title: '智能服务订单列表',
        requireLogin: true
      }
    },
    {
      path: '/my_order/service_order_info',
      name: 'Serviceorderinfo',
      component: () => import('@/views/myorder/Serviceorderinfo'),
      meta: {
        title: '订单详情',
        requireLogin: true
      }
    },
    /** 保险订单列表 **/
    {
      path: '/my_order/insurance_order_list',
      name: 'Insuranceorderlist',
      component: () => import('@/views/myorder/Insuranceorderlist'),
      meta: {
        title: '保险订单列表',
        requireLogin: true
      }
    },


  ]);
})();

//================================== 服务
(function () {
  tmpRoutes.push.apply(tmpRoutes, [

    /** 服务首页 **/
    {
      path: '/',//service
      name: 'ServiceIndex',
      component: () => import('@/views/service/Index'),
      meta: {
        title: '服务首页',
        requireLogin: true
      }
    },
    /** 门店列表 **/
    {
      path: '/storelist',
      name: 'StoreList',
      component: () => import('@/views/service/StoreList'),
      meta: {
        title: '门店列表',
        requireLogin: false
      }
    },
    /** 智能服务续费 **/
    {
      path: '/service/renewal',
      name: 'Renewal',
      component: () => import('@/views/service/Renewal'),
      meta: {
        title: '智能服务',
        requireLogin: true
      }
    },
    /** 智能服务续费成功 **/
    {
      path: '/service/renewal_success',
      name: 'RenewalSuccess',
      component: () => import('@/views/service/RenewalSuccess'),
      meta: {
        title: '续费成功 ',
        requireLogin: true
      }
    },
    /** 车辆转让 **/
    {
      path: '/service/transfer',
      name: 'Transfer',
      component: () => import('@/views/service/Transfer'),
      meta: {
        title: '车辆转让',
        requireLogin: true
      }
    },
    /** 电子保卡 **/
    {
      path: '/service/warrantycard',
      name: 'Warrantycard',
      component: () => import('@/views/service/Warrantycard'),
      meta: {
        title: '电子保卡',
        requireLogin: true
      }
    },
    /** 后台--电子保卡 **/
    {
      path: '/service/Backstagewarrantycard',
      name: 'BackstageWarrantycard',
      component: () => import('@/views/service/BackstageWarrantycard'),
      meta: {
        title: '电子保卡',
        requireLogin: false
      }
    },
    /** 产品合格证 **/
    {
      path: '/service/certificatecard',
      name: 'Certificatecard',
      component: () => import('@/views/service/Certificatecard'),
      meta: {
        title: '产品合格证',
        requireLogin: true
      }
    },
    /** 后台--产品合格证 **/
    {
      path: '/service/BackstageCertificatecard',
      name: 'BackstageCertificatecard',
      component: () => import('@/views/service/BackstageCertificatecard'),
      meta: {
        title: '产品合格证',
        requireLogin: false
      }
    },
    /** 已投保车辆  **/
    {
      path: '/insurance',
      name: 'InsuranceInsured',
      component: () => import('@/views/service/insurance/Index'),
      meta: {
        title: '已投保车辆',
        requireLogin: true
      }
    },
    /** 车辆挂失 **/
    {
      path: '/service/loss',
      name: 'Loss',
      component: () => import('@/views/service/loss/Index'),
      meta: {
        title: '车辆挂失',
        requireLogin: false
      }
    },
    /** 道路救援 地图 **/
    {
      path: '/rescue',//by_map
      name: 'Rescue',//ByMap
      component: () => import('@/views/service/rescue/Index'),
      meta: {
        title: '道路救援',
        requireLogin: true
      }
    },
    /** 道路救援 列表 **/
    // {
    //   path: '/rescue/by_list',
    //   name: 'RescueByList',
    //   component: () => import('@/views/service/rescue/RescueByList'),
    //   meta: {
    //     title: '道路救援',
    //     requireLogin: false
    //   }
    // },
  ]);
})();

//================================== 使用指南
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      path: '/help',
      name: 'HelpIndex',
      component: () => import('@/views/service/help/Index'),
      meta: {
        requireLogin: false
      }
    },
    {
      path: '/help_list',
      name: 'HelpList',
      component: () => import('@/views/service/help/List'),
      meta: {
        requireLogin: false
      }
    },
  ]);
})();

//================================== 附带文档
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      path: '/doc/terms_of_service',
      name: 'TermsOfService',//用户协议
      component: () => import('@/views/doc/TermsOfService'),
      meta: {
        requireLogin: false
      }
    },
    {
      path: '/doc/privacy_agreement',
      name: 'PrivacyAgreement',//隐私协议
      component: () => import('@/views/doc/PrivacyAgreement'),
      meta: {
        requireLogin: false
      }
    },
    {
      path: '/doc/smartservice_agreement',
      name: 'SmartserviceAgreement',//智能服务协议
      component: () => import('@/views/doc/SmartserviceAgreement'),
      meta: {
        requireLogin: false
      }
    },
    {
      path: '/doc/payment_agreement',
      name: 'PaymentAgreement',//支付协议
      component: () => import('@/views/doc/PaymentAgreement'),
      meta: {
        requireLogin: false
      }
    },
    {
      path: '/viewpdf',
      name: 'Viewpdf',//预览pdf
      component: () => import('@/views/viewpdf'),
    },
  ]);
})();

//================================== 测试
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      path: '/test_api',
      name: 'TestApi',
      component: () => import('@/views/test/Api'),
    },
  ]);
})();

//================================== 后台测试
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      path: '/backstage',
      name: 'BackstageIndex',
      component: () => import('@/views/backstage/Index'),
    },
  ]);
})();


//================================== 兜底
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      path: '*',
      redirect: '/',
    },
  ]);
})();

export default new Router({
  //mode: 'history',
  //base: '/',    
  //base: '/build/',
  routes: tmpRoutes,
})



// WEBPACK FOOTER //
// ./src/router/index.js